import { acceptableImageFormat } from '../constants/FilterDataValues';
import { errorMsg } from '../constants/messages';

// Categories are loaded from DB (`/news/categories`). Keep only a UI fallback.
const categoryOptions = [{ name: 'General', value: 'General' }];

const NewsArticleFormData = [
  {
    title: 'News Article Details',
    name: 'id',
    label: 'Id',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Id', enableSort: false, allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'title',
    label: 'Title',
    fieldType: {
      name: 'text',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Title', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    placeholder: 'Enter news title',
  },
  {
    name: 'slug',
    label: 'URL Slug',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Slug', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    placeholder: 'e.g. south-korea-tourist-visa-2026 (auto-generated from title if empty)',
  },
  {
    name: 'category',
    label: 'Category',
    fieldType: {
      name: 'select',
      options: categoryOptions,
      allowCustom: true,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Category', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: 'General',
    placeholder: 'Select or type a new category',
  },
  {
    name: 'summary',
    label: 'Summary / Excerpt',
    fieldType: {
      name: 'textarea',
      maxLength: 300,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Summary' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    placeholder: 'Enter short summary for listing cards and SEO description (max 300 characters)',
  },
  {
    name: 'imageUrl',
    label: 'Cover Image',
    fieldType: {
      name: 'newsArticleFile',
      accept: acceptableImageFormat,
      maxCount: 1,
      allowImageCropping: true,
    },
    placeholder: 'Click here to select image',
    required: false,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Cover Image',
      enableSort: false,
      allowAddRecordClick: false,
      columnType: 'image',
    },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'content',
    label: 'Full Article Content',
    fieldType: {
      name: 'textEditor',
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Content' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    placeholder: 'Write the complete article content with headings, paragraphs, and lists...',
  },
  {
    name: 'relatedNewsIds',
    label: 'Related News Articles',
    fieldType: {
      name: 'multiSelect',
      options: [],
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Related News' },
    isTableHeader: false,
    isAccordian: true,
    default: [],
    placeholder: 'Select related news articles to display in the carousel (optional)',
  },
  {
    name: 'metaTitle',
    label: 'SEO Meta Title',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Meta Title' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    placeholder: 'Enter SEO Meta Title (optional)',
  },
  {
    name: 'metaDescription',
    label: 'SEO Meta Description',
    fieldType: {
      name: 'textarea',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Meta Description' },
    isTableHeader: false,
    isAccordian: true,
    default: '',
    placeholder: 'Enter SEO Meta Description (optional)',
  },
  {
    name: 'readTime',
    label: 'Read Time',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Read Time' },
    isTableHeader: true,
    isAccordian: true,
    default: '4 min read',
    placeholder: 'e.g. 4 min read',
  },
  {
    name: 'publishedDate',
    label: 'Published Date',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Published Date' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
    placeholder: 'e.g. Aug 1, 2026',
  },
  {
    name: 'isPublished',
    label: 'Is Published',
    fieldType: {
      name: 'radio',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Published', columnType: 'boolean' },
    isTableHeader: true,
    isAccordian: true,
    default: true,
  },
];

export { NewsArticleFormData, categoryOptions };
export default NewsArticleFormData;
